import { ListLayout } from '@ingrid/luterkort-react';

import { Schema } from '../queries';

interface Props {
  schema: Schema;
  path?: string;
}

interface ArrayItemProps {
  schema: Schema;
  value: string;
  index: number;
}

function ArrayItem({ value, index, schema }: ArrayItemProps) {
  return (
    <ListLayout.Stack>
      <ListLayout.SecondaryText>{`${schema.title} #${index}`}</ListLayout.SecondaryText>
      <ListLayout.PrimaryText>{value ? value : '-'}</ListLayout.PrimaryText>
    </ListLayout.Stack>
  );
}

export function SchemaDisplayArray({ schema }: Props) {
  if (schema.type !== 'array') {
    return null;
  }

  return (
    <ListLayout.Stack>
      <ListLayout.Column>
        {schema.value?.map((v, index) => (
          <ArrayItem value={v} schema={schema} index={index} key={index} />
        ))}
      </ListLayout.Column>
    </ListLayout.Stack>
  );
}
